import React from 'react';
import styles from './SurferWeekPopup.module.scss';
import Modal from '../../../common/Modal/Modal';
import Button from '../../../common/Button/Button';
import { translate } from '../../../utility/messageTranslator/translate';
import { useIntl } from 'react-intl';

type Props = {
  onClose: () => void;
  onClick: () => void;
  isOpen: boolean;
  image: string;
  isButtonVisible: boolean;
};

export const SurferWeekPopup = ({
  onClose,
  onClick,
  isOpen,
  image,
  isButtonVisible,
}: Props) => {
  const intl = useIntl();

  return (
    <Modal onClose={onClose} isOpen={isOpen} className={styles.surferWeekPopup}>
      <img
        src={image}
        className={styles.surferImg}
        alt={translate(
          intl,
          'SURFER_WEEK_POPUP.IMAGE_ALT',
          'Citywave pasiūlymas',
        )}
      />
      {isButtonVisible && (
        <Button
          isLoadingButton
          onClick={onClick}
          buttonVariant="contained"
          color="primary"
          type="submit"
          className={styles.submitButton}
        >
          {translate(intl, 'SURFER_WEEK_POPUP.BUY_BUTTON', 'Pirkti dabar')}
        </Button>
      )}
    </Modal>
  );
};

export default SurferWeekPopup;
